import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { duration, easing, prefersReducedMotion } from "./animation/motion";

const DEFAULT_IMAGES = [
    "/images/peer-peer.png",
    "/images/athlete-athlete.png",
    "/images/youth-guardian.png",
    "/images/ai-peer.png",
] as const;

export interface HeroImageCarouselProps {
    /** Image URLs to crossfade between. Defaults to the homepage relationship set. */
    images?: readonly string[];
    /** How long each slide stays fully visible before fading, in ms. */
    intervalMs?: number;
    /** Crossfade duration in ms. */
    fadeMs?: number;
}

/**
 * Absolute-fill crossfade carousel for HeroSection's `image` slot.
 */
const HeroImageCarousel: React.FC<HeroImageCarouselProps> = ({
    images = DEFAULT_IMAGES,
    intervalMs = 5000,
    fadeMs = duration.normal * 2,
}) => {
    const [index, setIndex] = useState(0);
    const reducedMotion = prefersReducedMotion();

    useEffect(() => {
        if (reducedMotion || images.length <= 1) return;
        const id = window.setInterval(() => {
            setIndex((current) => (current + 1) % images.length);
        }, intervalMs);
        return () => window.clearInterval(id);
    }, [images.length, intervalMs, reducedMotion]);

    return (
        <>
            {images.map((src, i) => (
                <Box
                    key={src}
                    component="img"
                    src={src}
                    alt=""
                    sx={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center center",
                        pointerEvents: "none",
                        opacity: i === index ? 1 : 0,
                        transition: reducedMotion
                            ? "none"
                            : `opacity ${fadeMs}ms ${easing.enter}`,
                    }}
                />
            ))}
        </>
    );
};

export default HeroImageCarousel;
